import { render, staticRenderFns } from "./AttachmentUploadForm.vue?vue&type=template&id=f216d444&"
import script from "./AttachmentUploadForm.vue?vue&type=script&lang=js&"
export * from "./AttachmentUploadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports